<template>
  <vs-row vs-type="flex" vs-w="12" id="WalletTransaction">
    <vs-row vs-type="flex" vs-w="12">
      <vs-row vs-type="flex" vs-w="12" class="mb-1">
        <global-filter ref="filterer" :tableOptions="tableOptions" :filterOptions="filterOptions"
                       :filterChips="filterChips" :filterOptionNames="filterOptionNames" :isActive="isFilterActive"
                       @saveOptions="saveOptions" @close="isFilterActive = false;"/>
        <vs-row id="panelHeaderRow" v-show="!isFilterActive" vs-type="flex" vs-w="12" vs-justify="space-between">
          <vs-col id="panel-actions" vs-type="flex" class="w-auto" vs-justify="flex-start">
            <vs-row vs-type="flex" vs-w="12">
              <vs-col vs-type="flex" class="w-auto">
                <vx-tooltip text="Detaylı Filtereleme" position="top">
                  <vs-button @click="isFilterActive = !isFilterActive;"
                    class="panel-action text-warning xlarge-button panel-action-box-shadow" color="transparent"
                    icon-pack="pickicon" icon="icon-pick-filter">
                  </vs-button>
                </vx-tooltip>
              </vs-col>
              <vs-col vs-type="flex" class="w-auto">
                <vx-tooltip text="Excel Export" position="top">
                  <vs-button @click="getExcel" class="panel-action text-dark xlarge-button panel-action-box-shadow"
                             color="transparent" icon-pack="feather" icon="icon-download">
                  </vs-button>
                </vx-tooltip>
              </vs-col>
            </vs-row>
          </vs-col>
          <vs-col id="filter-chips" vs-type="flex">
            <vs-row vs-type="flex" vs-w="12" vs-justify="center" vs-align="center">
              <vs-button id="clearFilterButton" v-if="filterChips.length > 0" @click="clearFilter"
                class="mr-2 bg-white text-danger panel-action-box-shadow" icon-pack="feather" icon="icon-slash" radius
                color="transparent" />
              <vs-col vs-type="flex" class="w-auto" v-for="(chip,index) in filterChips" :key="index">
                <vs-chip color="white" class="panel-action-box-shadow px-1" @click="removeFilter(chip.col,index)"
                  v-show="chip.value != '' " closable>
                  <vs-row vs-tpye="flex" vs-w="12">
                    <vs-col vs-tpye="flex" class="w-auto" vs-align="center">
                      <span class="bold text-xsmaller text-dark">
                        {{chip.name + ' :'}}
                      </span>
                    </vs-col>
                    <vs-col vs-type="flex" class="w-auto ml-1" vs-align="center">
                      <span class="weight-600 italic text-xsmaller text-primary">
                        {{chip.value}}
                      </span>
                    </vs-col>
                  </vs-row>
                </vs-chip>
              </vs-col>
            </vs-row>
          </vs-col>
        
        </vs-row>
      </vs-row>
    </vs-row>
    <vs-row vs-type="flex" vs-w="12">
        <vs-row vs-type="flex" vs-w="12">
    <vs-row id="branchReportHeaderChips" vs-type="flex" vs-w="12" class="mt-4" vs-align="center"
            vs-justify="space-between">
      <vs-col vs-type="flex" vs-sm="12" vs-w="3"
              class="bg-white py-3 px-2 my-1 sale-box-shadow low-border-radius">
        <vs-row vs-type="flex" vs-w="12">
          <vs-col vs-type="flex" class="w-auto" vs-align="center">
            <vs-button size="large" radius icon-pack="pickicon" class="giroChip" color="transparent" icon="icon-rich"/>
          </vs-col>
          <vs-col vs-type="flex" vs-w="9" class="pl-2" vs-align="center">
            <vs-row vs-type="flex" vs-w="12">
              <vs-row vs-type="flex" vs-w="12">
                <span class="text-medium-small2 bold" style="color:#51C2C2;">
                  {{ reportData.totalAmount }} TL
                </span>
              </vs-row>
              <vs-row vs-type="flex" vs-w="12">
                <span class="text-secondary text-xsmall weight-600">
                  {{ ' Kazanılan Ciro' }}
                </span>
              </vs-row>
            </vs-row>
          </vs-col>
        </vs-row>
      </vs-col>
      <vs-col vs-type="flex" vs-sm="12" vs-w="3"
              class="bg-white py-3 px-2 my-1 sale-box-shadow low-border-radius">
        <vs-row vs-type="flex" vs-w="12">
          <vs-col vs-type="flex" class="w-auto" vs-align="center">
            <vs-button size="large" radius icon-pack="pickicon" class="giroChip" color="transparent" icon="icon-rich"/>
          </vs-col>
          <vs-col vs-type="flex" vs-w="9" class="pl-2" vs-align="center">
            <vs-row vs-type="flex" vs-w="12">
              <vs-row vs-type="flex" vs-w="12">
                <span class="text-medium-small2 bold" style="color:#51C2C2;">
                  {{ reportData.totalRefund }} TL
                </span>
              </vs-row>
              <vs-row vs-type="flex" vs-w="12">
                <span class="text-secondary text-xsmall weight-600">
                  Toplam iade
                </span>
              </vs-row>
            </vs-row>
          </vs-col>
        </vs-row>
      </vs-col>
      <vs-col vs-type="flex" vs-sm="12" vs-w="3"
              class="bg-white py-3 px-2 my-1 sale-box-shadow low-border-radius">
        <vs-row vs-type="flex" vs-w="12">
          <vs-col vs-type="flex" class="w-auto" vs-align="center">
            <vs-button size="large" radius icon-pack="pickicon" class="giroChip" color="transparent" icon="icon-rich"/>
          </vs-col>
          <vs-col vs-type="flex" vs-w="9" class="pl-2" vs-align="center">
            <vs-row vs-type="flex" vs-w="12">
              <vs-row vs-type="flex" vs-w="12">
                <span class="text-medium-small2 bold" style="color:#51C2C2;">
                  {{ reportData.totalDifference }} TL
                </span>
              </vs-row>
              <vs-row vs-type="flex" vs-w="12">
                <span class="text-secondary text-xsmall weight-600">
                  Toplam Kar
                </span>
              </vs-row>
            </vs-row>
          </vs-col>
        </vs-row>
      </vs-col>
    </vs-row>
  </vs-row>
    </vs-row>
  </vs-row>
</template>


<script>
import {
    GetWalletTransactionExcel,
    GetWalletTransaction
} from "@/api/Reports.js";
    import GlobalFilter from "../../GlobalFilter";
    export default {
  components: {
    GlobalFilter
  },
  data() {
    return {
        tableOptions: {},
        isFilterActive: false,
        filterChips: [],
        reportData: {},
        filterOptions: ["branch", "dateRange"],
        filterOptionNames: ["Şube","Tarih"]
    }
  },
  mounted() {
    this.clearFilter();
  },
  methods:{
    saveOptions(filterOptions, filterChips) {
      this.isFilterActive = false;
      if (_.isEqual(this.tableOptions, filterOptions)) return;
      this.tableOptions = _.cloneDeep(filterOptions);
      this.filterChips = _.cloneDeep(filterChips);
    },
    removeFilter(col, index) {
        this.tableOptions[col] = null;
        this.filterChips.splice(index, 1);
      },
    clearFilter() {
      this.tableOptions = {
        dateRange: {
          startDate: null,
          endDate: null
        },
        sortBy: 'rawMaterial.Name',
        branch: null,
        rawMaterial: null,
        defaultTimeRange: this.$now().getHours() >= 0 && this.$now().getHours() <= 2 ? {
          name: "Yesterday",
          id: 0,
          dName: "Dün"
        } : {
          name: "Today",
          id: 1,
          dName: "Bugün"
        },
        sortDirection: this.directions[0]
      };
      this.filterChips.length = 0;
    },
    getExcel() {
        GetWalletTransactionExcel(this.tableOptions).then(res => {
        if (res && res.status == 200) {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.href = url;
          let now = this.$now.date();
          link.setAttribute('download', 'Hammadde Tüketim Raporu' + now.getDate() + " " + this.$months()[now.getMonth()]
            .name + " " + now.getFullYear() + '.xlsx');
          document.body.appendChild(link);
          link.click();

          this.$vs.notify({
            color: "success",
            title: "Başarılı",
            text: "Excel Export Başarılı !"
          });
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: "Excel Export İşlemi Başarısız !"
          });
        }
      }).catch(() => {
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "Sunucu Bağlantı Hatası !"
        });
      })
    },
    getTransactions(){
      GetWalletTransaction(this.tableOptions).then(res => {
        if (res && res.status == 200) {
          this.reportData = res.data;
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: "Rapor Hazırlanamadı"
          });
        }
      }).catch(() => {
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "Sunucu Bağlantı Hatası"
        });
      });
    }
  },
  watch: {
    tableOptions: {
      deep: true,
      handler(val) {
        this.$nextTick(() => {
          this.getTransactions();
        });
      }
    }
  }
  }
</script>